import React from "react";
import { KeyValue } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { formatVariantName, variantTypeLabel } from "../../utils/variantTitles";
import css from "./VariantTitles.module.css";
export var VariantTitlesList = function (_a) {
    var variants = _a.variants;
    var formatMessage = useIntl().formatMessage;
    if (!(variants === null || variants === void 0 ? void 0 : variants.length)) {
        return null;
    }
    return (React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.titles.variantTitles.label" }) },
        React.createElement("ul", { className: css.list, "data-testid": "variant-titles-list" }, variants.map(function (variant, index) {
            var _a, _b, _c;
            return (React.createElement("li", { key: "".concat(index, "|").concat(variant.name, "|").concat((_a = variant.subtitle) !== null && _a !== void 0 ? _a : "", "|").concat((_b = variant.typeCode) !== null && _b !== void 0 ? _b : "", "|").concat((_c = variant.marcType) !== null && _c !== void 0 ? _c : "") },
                formatVariantName(variant),
                " ",
                React.createElement("span", { className: css.type },
                    "(",
                    variantTypeLabel(variant, formatMessage),
                    ")")));
        }))));
};
